module.exports = __webpack_public_path__ + "img/3-3.5a4aff5a.png";